// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gs-6";
export var emphasizeQuantity = "_gs-3";
export var flatBottomCorners = "_gs-5";
export var productImage = "_gs-0";
export var quantityContainer = "_gs-2";
export var tooltip = "_gs-1";
export var wrapAndEllipsesOverflow = "_gs-4";